<template>
  <print-bill-frame
    ref="printbill"
    :is-preview="true"
  />
</template>

<script>
import PrintBillFrame from '@/components/PrintBillFrame'
export default {
  components: {
    'print-bill-frame': PrintBillFrame
  },
  mounted () {
    this.$refs.printbill.getBillData()
  }
}
</script>
